import type { FaireProductEntity } from "../../entity_types/product";

export const p_txh8b2c9h6: FaireProductEntity = {
  token: "p_txh8b2c9h6",
  type: "product",
  name: "Garden Party Organic Herbal Tea Sachets",
  brandToken: "b_9jd96k047p",
  brandName: "Rishi Tea & Botanicals",
  imageUrl:
    "https://cdn.faire.com/fastly/a2dbc8a2412014398653ecd2e5a0015ef97aefbf81dbb98e4014961005096ea6.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/991c341e1a13c220f2e4af79b796470ef7a34f61b436737d579b2221a73d8b6b.png",
  ],
  priceDollars: 10.39,
  description:
    "This item comes in a case of 6 retail boxes of 15 sachets.\n\nStep into a world of tea enchantment with the botanical bouquet of Garden Party. An endless summer awaits as notes of chamomile blossoms are uplifted with the alluring fragrance of neroli bitter orange. A blush of hibiscus, a burst of fresh-cut strawberry and the smooth sweetness of honeybush delight your palate. Ideal for quiet moments or shared connections, this tea will awaken your senses and transport you to a beautiful garden abounding in flowers and tranquility. Let your tea time blossom into something extraordinary.\n\nTASTING NOTES\nChamomile and neroli, with a kiss of hibiscus and strawberry\n\nCAFFEINE LEVEL\nNone",
  tags: [],
  msrpDollars: 13.86,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:59:11.916Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
